import { isNotDefined } from '@sgme/fp';

import type { BlotterOrderEntryFromBackend } from '@/store/blotter/api/types/BlotterOrderEntryFromBackend.ts';
import { type BlotterOrderEntry, convertOrderEntry } from '@/store/blotter/types/BlotterOrderEntry.ts';

/**
 * Converts incoming orders from the webapi format to the front format
 * @param orders the orders entries coming from the webapi
 */
export const convertOrdersForFront = (orders: BlotterOrderEntryFromBackend[]): Record<string, BlotterOrderEntry> => {
  const result: Record<string, BlotterOrderEntry> = {};
  for (const webapiEntry of orders) {
    const entry = convertOrderEntry(webapiEntry);
    if (isNotDefined(entry)) {
      continue;
    }
    result[entry.id] = entry;
  }
  return result;
};
